import React from "react";
import * as XLSX from "xlsx";

function ExcelToJsonConverter({ handleUpload, disabled }) {
  const handleConvert = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        handleUpload(json);
      };
      reader.readAsBinaryString(file);
    }
  };

  if (disabled) {
    return null;
  }

  return (
    <div>
      <input
        type="file"
        accept=".xls,.xlsx"
        onChange={(e) => handleConvert(e.target.files[0])}
      />
    </div>
  );
}

export default ExcelToJsonConverter;
